export const ru = {
    add_cost_center: 'Добавить центр затрат',
    const_center_name: 'Название центра затрат',
};
